import { render, staticRenderFns } from "./HelpView.vue?vue&type=template&id=cd3d9070"
import script from "./HelpView.vue?vue&type=script&lang=ts"
export * from "./HelpView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports